import { native } from '@forest/native-services'

// Fire-and-forget non-fatal report: a failed or unavailable bridge must
// never affect the flow that emitted the diagnostic.
export function logNonFatal(
  name: string,
  params: Record<string, string>,
): void {
  try {
    void native.general
      .logNonFatalError({ name, code: 1, params })
      .catch(() => {})
  } catch {
    // Bridge errors are swallowed with the report.
  }
}
